import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SuiInfiniteScroll } from '@splashthat/sui';
import { colorAppBorder, colorAppBackground } from 'common/styles/colors';
import { latoLineHeight } from 'common/styles/typography';

const FormUsageInfoText = styled.p`
    font-weight: bold;
    margin-bottom: 0.2rem;
`;

const ListContainer = styled.div`
    border: 1px solid ${colorAppBorder};
    background: ${colorAppBackground};
    max-height: 26.5vh;
`;

const List = styled.div`
    padding: 0.5rem 0.75rem;
    line-height: ${latoLineHeight};
    display: grid;
    flex-direction: row;
`;

const InfiniteScrollStyled = styled(SuiInfiniteScroll)`
    max-height: 26.5vh;
    overflow: 'auto';
`;

const FormUsageContainer = styled.div`
    margin-top: 0.5rem;
`;

const COMPONENT_NAME = 'FormUsageInfo';

const FormUsageList = ({ type, list }) => (
    <FormUsageContainer>
        <FormUsageInfoText data-qa={`${COMPONENT_NAME}__p-${type}`}>
            {type} ({list.length})
        </FormUsageInfoText>
        {list.length ? (
            <ListContainer>
                <InfiniteScrollStyled>
                    <List data-qa={`${COMPONENT_NAME}__list-${type}`}>
                        {list.map(({ domain, name }) => (
                            <a key={name} href={domain} target="_blank">
                                {name}
                            </a>
                        ))}
                    </List>
                </InfiniteScrollStyled>
            </ListContainer>
        ) : null}
    </FormUsageContainer>
);

FormUsageList.propTypes = {
    type: PropTypes.string.isRequired,
    list: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default FormUsageList;
